
@switch (type) {
  @case ('article') {
    <div class="image"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line" style="width: 75%"></div>
  }
  @case ('lines') {
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line" style="width: 75%"></div>
  }
  @default {
    <div class="line"></div>
  }
}
